// extracted by mini-css-extract-plugin
module.exports = {"container":"Start_container__3sFow","title":"Start_title__1nGO4","button":"Start_button__QT6h5"};